/* eslint-disable no-console */
const removeSelectedState = (swatchList) => {
  const selectedBtn = swatchList.querySelector('.selected');
  if (selectedBtn) {
    selectedBtn.classList.remove('selected');
  }
};

const updateActiveColor = (options) => {
  const {
    btn,
    swatchList,
    onUpdate,
  } = options;
  removeSelectedState(swatchList);
  btn.classList.add('selected');
  if (onUpdate) {
    onUpdate(btn);
  }
};

const addColorSwap = (options) => {
  const {
    btnSelector,
    groupSelector,
    runInit,
    onUpdate,
  } = options;
  const swatchList = document.querySelector(groupSelector);
  // Add event listeners
  const swatchBtns = swatchList.querySelectorAll(btnSelector);
  [].map.call(swatchBtns, btn => btn.addEventListener('click', () => {
    updateActiveColor({
      btn,
      swatchList,
      onUpdate,
    });
  }));
  // Init
  if (runInit) {
    const selectedBtn = swatchList.querySelector('.selected');
    updateActiveColor({
      btn: selectedBtn,
      swatchList,
      onUpdate,
    });
  }
};

export {
  addColorSwap,
  updateActiveColor,
};
/* eslint-enable no-console */
